import React from 'react';
import Tooltip from './Tooltip';

const AdditionalItemGroupTooltip = ({ group, target, mobileMode, onClose }) => {
  if (!group || !group.items) return null;

  return (
    <Tooltip target={target} mobileMode={mobileMode} onClose={onClose}>
      {mobileMode && (
        <div className="tooltip-header">
          <button className="icon-button close-tooltip-button" onClick={onClose}>
            <i className="material-icons">close</i>
          </button>
        </div>
      )}
      <h4>{group.title}</h4>
      <hr />
      <ul>
        {group.items.map((item, index) => (
          <li key={index}>
            {item.name}{item.amount ? ` ${item.amount}` : ''}{item.unit ? ` ${item.unit}` : ''}
          </li>
        ))}
      </ul>
    </Tooltip>
  );
};

export default AdditionalItemGroupTooltip;